(function () {
  'use strict';

  const PREORDER_TEXT = 'Pre-order Now';
  const PREORDER_CLASS = 'is-preorder';
  const MESSAGE_CLASS = 'preorder-restock-message';

  const originalLabels = new WeakMap();

  function getProductForms() {
    return document.querySelectorAll(
      'form[action*="/cart/add"], ' +
      'form[data-product-form], ' +
      'form.product-form'
    );
  }

  function getAddToCartButton(form) {
    // Only target the first matching button in this form.
    return form.querySelector(
      '.add-to-cart, .gp-button-atc'
    );
  }

  function getVariantId(form) {
    const input = form.querySelector(
      'input[name="id"], select[name="id"]'
    );

    return input && input.value
      ? String(input.value)
      : null;
  }

  function getVariants(form) {
    // Quick-view-specific variant data takes priority.
    const dataElement = form.closest('[data-preorder-variants]') || form;

    const json = dataElement.getAttribute('data-preorder-variants');

    if (json) {
      try {
        const variants = JSON.parse(json);

        if (Array.isArray(variants)) {
          return variants;
        }
      } catch (error) {
        console.warn('[Preorder] Invalid variant JSON.', error);
      }
    }

    // Fallback for standard Shopify PDPs.
    const productData = window.ShopifyProductData;

    return productData && Array.isArray(productData.variants)
      ? productData.variants
      : [];
  }

  function isPreorder(variant) {
    return Boolean(
      variant &&
      variant.inventory_management &&
      Number(variant.inventory_quantity) <= 0 &&
      variant.inventory_policy === 'continue'
    );
  }

  function getLabelNode(button) {
    const walker = document.createTreeWalker(
      button,
      NodeFilter.SHOW_TEXT
    );

    let node;

    while ((node = walker.nextNode())) {
      if (node.nodeValue.trim()) {
        return node;
      }
    }

    return null;
  }

  function setButtonLabel(button, preorder) {
    button.classList.toggle(PREORDER_CLASS, preorder);

    if (button instanceof HTMLInputElement) {
      if (!originalLabels.has(button)) {
        originalLabels.set(button, {
          type: 'input',
          value: button.value
        });
      }

      const original = originalLabels.get(button);
      const label = preorder ? PREORDER_TEXT : original.value;

      if (button.value !== label) {
        button.value = label;
      }

      return;
    }

    if (!originalLabels.has(button)) {
      const node = getLabelNode(button);

      originalLabels.set(button, {
        node: node,
        value: node ? node.nodeValue : ''
      });
    }

    const original = originalLabels.get(button);
    let node = original.node;

    if (!node || !button.contains(node)) {
      node = getLabelNode(button);
    }

    if (!node) return;

    const originalText = original.value;
    const trimmed = originalText.trim();

    const label = preorder
      ? (trimmed
          ? originalText.replace(trimmed, PREORDER_TEXT)
          : PREORDER_TEXT)
      : originalText;

    if (node.nodeValue !== label) {
      node.nodeValue = label;
    }
  }

  function updateRestockMessage(button, variant, preorder) {
    const parentRow = document.querySelector('#preorder-message-container') || button.closest('gp-row');

    if (!parentRow) return;

    let wrapper = parentRow.previousElementSibling;

    if (!wrapper || !wrapper.classList.contains(MESSAGE_CLASS)) {
      wrapper = document.createElement('div');
      wrapper.className = MESSAGE_CLASS;
      wrapper.setAttribute('aria-live', 'polite');

      parentRow.insertAdjacentElement('beforebegin', wrapper);
    }
    

    const messageText = variant.preorder_message ? variant.preorder_message.trim() : '';
    const shippingMessageText = variant.preorder_shipping_message ? variant.preorder_shipping_message.trim() : '';

    const shouldShow = preorder && Boolean(messageText);
    
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none">
      <path d="M3.9889 14.6604L2.46891 13.1404C1.84891 12.5204 1.84891 11.5004 2.46891 10.8804L3.9889 9.36039C4.2489 9.10039 4.4589 8.59038 4.4589 8.23038V6.08036C4.4589 5.20036 5.1789 4.48038 6.0589 4.48038H8.2089C8.5689 4.48038 9.0789 4.27041 9.3389 4.01041L10.8589 2.49039C11.4789 1.87039 12.4989 1.87039 13.1189 2.49039L14.6389 4.01041C14.8989 4.27041 15.4089 4.48038 15.7689 4.48038H17.9189C18.7989 4.48038 19.5189 5.20036 19.5189 6.08036V8.23038C19.5189 8.59038 19.7289 9.10039 19.9889 9.36039L21.5089 10.8804C22.1289 11.5004 22.1289 12.5204 21.5089 13.1404L19.9889 14.6604C19.7289 14.9204 19.5189 15.4304 19.5189 15.7904V17.9403C19.5189 18.8203 18.7989 19.5404 17.9189 19.5404H15.7689C15.4089 19.5404 14.8989 19.7504 14.6389 20.0104L13.1189 21.5304C12.4989 22.1504 11.4789 22.1504 10.8589 21.5304L9.3389 20.0104C9.0789 19.7504 8.5689 19.5404 8.2089 19.5404H6.0589C5.1789 19.5404 4.4589 18.8203 4.4589 17.9403V15.7904C4.4589 15.4204 4.2489 14.9104 3.9889 14.6604Z" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M9 15L15 9" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M14.4945 14.5H14.5035" stroke="#292D32" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M9.49451 9.5H9.50349" stroke="#292D32" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

    const contentHtml = shippingMessageText
      ? `${messageText}<br><span class="preorder-restock-shipping">${shippingMessageText}</span>`
      : messageText;

    const text = shouldShow
      ? `<div class="preorder-banner">
          <div class="preorder-icon">
            ${svg}
          </div>
          <div class="preorder-text-content">
            ${contentHtml}
          </div>
        </div>`
      : '';

    if (wrapper.innerHTML !== text) {
      wrapper.innerHTML = text;
    }

    wrapper.hidden = !shouldShow;
  }

  function updateForm(form) {
    const button = getAddToCartButton(form);

    if (!button) return;

    const variantId = getVariantId(form);

    if (!variantId) return;

    const variants = getVariants(form);

    const variant = variants.find(
      item => String(item.id) === variantId
    );

    if (!variant) return;

    const preorder = isPreorder(variant);

    setButtonLabel(button, preorder);
    updateRestockMessage(button, variant, preorder);
  }

  function showSaleBadge() {
    const selector = '#MainContent product-form gp-product-badge';

    function setStyleIfNeeded(element, property, value) {
      if (
        element.style.getPropertyValue(property) !== value ||
        element.style.getPropertyPriority(property) !== 'important'
      ) {
        element.style.setProperty(property, value, 'important');
      }
    }

    function forceShow(badge) {
      if (badge.getAttribute('gp-data-hidden') !== 'false') {
        badge.setAttribute('gp-data-hidden', 'false');
      }

      setStyleIfNeeded(badge, 'display', 'block');
      setStyleIfNeeded(badge, 'visibility', 'visible');
      setStyleIfNeeded(badge, 'opacity', '1');
    }

    function hideBadge(badge) {
      if (badge.getAttribute('gp-data-hidden') !== 'true') {
        badge.setAttribute('gp-data-hidden', 'true');
      }

      setStyleIfNeeded(badge, 'display', 'none');
    }

    function updateBadge(badge) {
      const text = badge.textContent.trim();

      // Hide badge if it contains a standalone 0% percentage.
      // Does not match 10%, 20%, 30%, 50%, etc.
      if (/(^|\D)0%(?!\d)/.test(text)) {
        hideBadge(badge);
        return;
      }

      forceShow(badge);
    }

    document.querySelectorAll(selector).forEach((badge) => {
      updateBadge(badge);

      if (badge.dataset.saleBadgeObserver) return;

      badge.dataset.saleBadgeObserver = 'true';

      const observer = new MutationObserver(() => {
        updateBadge(badge);
      });

      observer.observe(badge, {
        attributes: true,
        attributeFilter: ['style', 'gp-data-hidden'],
        childList: true,
        characterData: true,
        subtree: true
      });
    });
  }

  function updateAllForms() {
    getProductForms().forEach(updateForm);
  }

  function updateAfterInteraction(form) {
    requestAnimationFrame(() => updateForm(form));
  }

  document.addEventListener('change', event => {
    const target = event.target;

    if (!target.closest) return;

    const form = target.closest(
      'form[action*="/cart/add"], ' +
      'form[data-product-form], ' +
      'form.product-form'
    );

    if (form) {
      updateAfterInteraction(form);
    } else {
      updateAllForms();
    }
  });

  document.addEventListener('click', event => {
    const target = event.target;

    if (!target.closest) return;

    const form = target.closest(
      'form[action*="/cart/add"], ' +
      'form[data-product-form], ' +
      'form.product-form'
    );

    if (form) {
      updateAfterInteraction(form);
    }
  });

  [
    'variant:change',
    'variant:changed',
    'product:variant-change'
  ].forEach(eventName => {
    document.addEventListener(eventName, updateAllForms);
  });

  function init() {
    showSaleBadge();
    updateAllForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {
      once: true
    });
  } else {
    init();
  }
})();